import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { rpLimitFormSchema, TRpLimitFormData } from './schema'

export const useRpLimitForm = (defaultValues?: Partial<TRpLimitFormData>) => {
  return useForm<TRpLimitFormData>({
    resolver: zodResolver(rpLimitFormSchema),
    defaultValues: {
      name: '',
      min: 1,
      max: undefined,
      maxPayout: undefined,
      ...defaultValues,
    },
  })
}
